import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import LCD from '../Features/LCD';

export default class LCDSetScreenNode extends BaseNode {
    constructor() {
        super();
        this.name = 'LCD Set Screen';
        this.id = 'node_lcd_set_screen';
        this.linkedFeature = 'display_lib';
        this.icon = 'CgScreen';
        this.requirements = ['tios'];

        this.inputs = [
            {
                name: 'Set Screen',
                portId: 'set_screen',
                params: [],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'SCREEN',
                name: 'Screen',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'display_screen',
                default: '',
                options: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getName(): string {
        const name = this.getSettingValueOptionName('SCREEN');
        return `Set Screen ${name} visible`;
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            return this.getName();
        }
        return super.getSettingValue(settingId);
    }


    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;

        const links = project.getNodeLinks(this, 'set_screen');
        const doneLinks = project.getNodeLinks(this, 'done');

        const doneBlock = doneLinks.length > 0 ? `${project.getCodeLocationStart()}${doneLinks[0].getSourceId()}${project.getCodeLocationEnd()}` : '';

        const SCREEN = this.getSettingValue('SCREEN');

        let index = 0;
        for (let i = 0; i < project.features.length; i++) {
            const feature = project.features[i];
            for (let j = 0; j < feature.settings.length; j++) {
                const setting = feature.settings[j];
                if (setting.refId === 'display_screen'
                    && setting.settingType === SettingType.ARRAY) {
                    for (let k = 0; k < setting.value.length; k++) {
                        if (setting.value[k].getID() === SCREEN) {
                            break;
                        }
                        index++;
                    }
                }
            }
        }

        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            switch (project.runtime) {
                case 'tios':
                    blocks.push({
                        location: link.getSourceId(),
                        blockType: BlockType.CODE,
                        id: link.getID(),
                        template: `
        lcd_display_widgets(${index.toString()})
        ${doneBlock}`,
                    });
                    break;
                case 'micropython':
                    blocks.push({
                        location: link.getSourceId(),
                        blockType: BlockType.CODE,
                        id: link.getID(),
                        template: `
${doneBlock}`,
                    });
                    break;
                case 'simulator':
                    {
                        const lcdFeatureId = this.project.getFeature('lcd').getID();
                        blocks.push({
                            location: link.getSourceId(),
                            blockType: BlockType.CODE,
                            id: link.getID(),
                            template: `
    simulator.updateContext("${lcdFeatureId}", {
        ...simulator.context["${lcdFeatureId}"],
        currentScreenIndex: ${index},
        BACKCOLOR: simulator.context["${lcdFeatureId}"].SCREENS[${index}].BACKCOLOR,
    });
    ${doneBlock}`,
                        });
                    }
                    break;
                default:
                    break;
            }
        }

        return blocks;
    }

    getDetails(): string {
        return 'Sets current visible screen on the LCD display.';
    }
}
